<template>
  <div class="as-loading">
    Đang tải, vui lòng chờ lại <br />
    <br />
    <img src="https://embed.plcdn.xyz/images/loading.gif" border="0" />
    <br />
    <br />
    Sau khi hiển thị, trang web được làm mới tự động, bạn không cần làm mới
    trang tận tay. <br />
  </div>
</template>

<script lang="ts">
export default {};
</script>
